import React, { useState, useEffect, useContext } from 'react';
import {format, addDays} from "date-fns";

import * as net from "../../lib/net";
import Dt_Cal from "../../lib/ui/dt_cal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ddo from "../../ddo";

class Pms_Stat_Wnd extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_fd = React.createRef();
    this.dt_td = React.createRef();

    this.state = {};
    this.state.ynq = [];
    this.state.aa = [];
    this.state.cols = {};
    this.state.ix = 0;
    this.state.sz_val = "";
    this.state.szo = {};
    this.state.sza = [];

    this.state.today = new Date();
    var hh = format(this.state.today, "hh");
    if(hh < 5) this.state.today.setDate(this.state.today.getDate() - 1);
    this.state.fdat = format(this.state.today, "yyyy-MM-dd");
    var tdat = addDays(this.state.today, 15);
    this.state.tdat = format(tdat, "yyyy-MM-dd");
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
		this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }

  acs() {
    var self = this;
    var prm = {};
    prm.req = "pms.ac.ac_list";
    prm.fdat = "20200915";
    prm.tdat = "20200915";
    //prm.avd = this.state.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        self.setState({aca: ret.rco });
        self.syncCols("acsTable");
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }

    val_save (name, value) {
        var szo = this.state.szo;
        if(!szo[name]) {
            szo = {};
        }
        szo[name] = value;
        this.setState({szo: szo});
    }
  sz_edit(row) {
    var self = this;
    this.props.ctx.setState({ szw: false, rvo: true, boknr: row.boknr });
 }
  dt_fdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ fdat: dts });
  }
  dt_tdat(e) {
      //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ tdat: dts });
  }
  oneday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_td.current.updateDt(this.state.fdat);
  }
  addday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateAdd();
    this.dt_td.current.updateAdd();
  }
  subday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateSub();
    this.dt_td.current.updateSub();
  }

  render() {
    if(!this.props.show) return "";

    //alert(this.props.ctx.state.lro);

    var title = this.props.title;
    if(!title) title = "Sök";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_80 flex-col" style={ this.dlg_style() }>
        <div className="mx_content flex">

            <div className="mx_h01 flex-row" style={{background: "#1a456b", color: "#fff"}}>
                    <div className="flex-col flex">
                        <div>HOTELL STATUS</div>
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>
        <div className="flex-row hide">
              <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
              <Dt_Cal dts={this.state.fdat} rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
              <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
              <Dt_Cal dts={this.state.tdat} rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
              <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
        </div>
            <div className="divider_orange"></div>

            <div className="flex-row txt-16 py-5 flex">

            <div className="flex-col flex px-5">
            <div className="">
              ANKOMMANDE RUM: { ddo.cache.pms.stat.ankr}
             </div>
             <div className="">
              ANKOMMANDE GÄSTER: { ddo.cache.pms.stat.ankg}
            </div>
            <div className="">
              AVRESANDE RUM: { ddo.cache.pms.stat.avrg}
            </div>
            <div className="">
            AVRESANDE GÄSTER: { ddo.cache.pms.stat.avrg}
            </div>
            </div>
 
            <div className="flex-col flex px-5">
            <div className="">
              BOENDE RUM: { ddo.cache.pms.stat.borr}
             </div>
             <div className="">
             BOENDE GÄSTER: { ddo.cache.pms.stat.borg}
            </div>
            </div>

            </div>

        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            <button className="btn btn-hw-green w250" onClick={(event) => this.sz_do(event) } >
                SKRIV UT
            </button>
            </div>
      </div>
    </div>
    </div>
	;
	return html;
  };
}

export default Pms_Stat_Wnd;